module.exports = "/assets/SLstPPDfdu.png";